/** @jsx jsx */
import type { PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type LineItemProps = {
	testId: string;
	lineItem: string;
	isSelected?: boolean;
	onInteraction: () => void;
};
export function LineItem(props: LineItemProps) {
	const { testId, lineItem, isSelected = false, onInteraction } = props;

	return (
		// Will be fixed on https://hello.jira.atlassian.cloud/browse/TAKO-1680
		// This elements are still accesibly by using the Carousel component
		// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
		<div role="listitem" data-testid={testId} onClick={onInteraction} onMouseEnter={onInteraction}>
			<Flex gap="space.250" alignItems="center">
				<Box xcss={isSelected ? selectedItemIndicatorStyles : nonSelectedItemIndicatorStyles} />
				<LineItemTextWrapper isSelected={isSelected}>{lineItem}</LineItemTextWrapper>
			</Flex>
		</div>
	);
}

const lineItemSelectedStyles = css({
	color: token('color.text'),
	fontWeight: 500,
});

const lineItemBaseStyles = css({
	font: token('font.heading.small'),
	fontWeight: 400,
	color: token('color.text.subtlest', '#626F86'),
	transition: 'color 0.7s ease-out',
});

type LineItemTextWrapperProps = PropsWithChildren<{ isSelected: boolean }>;

const LineItemTextWrapper = (props: LineItemTextWrapperProps) => {
	const { isSelected, children } = props;

	return <span css={[lineItemBaseStyles, isSelected && lineItemSelectedStyles]}>{children}</span>;
};

const nonSelectedItemIndicatorStyles = xcss({
	padding: 'space.025',
	backgroundColor: 'color.background.neutral.subtle',
	borderRadius: 'border.radius.100',
	minHeight: '32px',
});

const selectedItemIndicatorStyles = xcss({
	padding: 'space.025',
	backgroundColor: 'color.background.accent.blue.bolder',
	borderRadius: 'border.radius.100',
	minHeight: '32px',
	transition: 'background-color 0.7s ease-out',
});
